import { useMutation } from '@apollo/client';
import { AddUsersToOrgDocument, AssignPinboardsToGroupDocument, AssignUsersToGroupsFromUserDocument, CreateGroupDocument, CreateUserDocument, DeleteGroupDocument, DeleteUserDocument, GenerateOtpDocument, GetOrgStatisticsDocument, ResendGroupWelcomeEmailDocument, ResetMfaConifgDocument, SendWelcomeEmailDocument, Teams_ReInviteMemberDocument, UpdateGroupDocument, UpdateUserDocument, useGetDefaultLiveboardsLazyQuery as _useGetDefaultLiveboardsLazyQuery, useGetEdocLazyQuery as _useGetEdocLazyQuery, useGetGroupDetailsByIdLazyQuery as _useGetGroupDetailsByIdLazyQuery, useGetGroupMembersLazyQuery as _useGetGroupMembersLazyQuery, useGetGroupsPrincipalListQuery as _useGetGroupsPrincipalListQuery, useGetUserAccessibleOrgsQuery as _useGetUserAccessibleOrgsQuery, useGetUserAndGroupPrincipalListLazyQuery as _useGetUserAndGroupPrincipalListLazyQuery, useGetUserAndGroupPrincipalListQuery as _useGetUserAndGroupPrincipalListQuery, useGetUserAndGroupsQuery as _useGetUserAndGroupsQuery, useGetUserDetailsByIdLazyQuery as _useGetUserDetailsByIdLazyQuery, useGetUserDetailsByIdWithUsersListLazyQuery as _useGetUserDetailsByIdWithUsersListLazyQuery, useGetUserGroupsPrincipalListQuery as _useGetUserGroupsPrincipalListQuery, useGetUsersPrincipalListQuery as _useGetUsersPrincipalListQuery, } from '../generated/graphql-types';
export const useGetUsersListPrincipalQuery = (input) => {
    const { data, error, loading, refetch } = _useGetUsersPrincipalListQuery({
        variables: {
            data: input,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.getUsersPrincipalList,
        refetch,
    };
};
export const useGetUserGroupPrincipalListQuery = (pattern, skipIds, batchSize) => {
    const { data, error, loading, refetch, } = _useGetUserGroupsPrincipalListQuery({
        variables: {
            pattern,
            skipIds,
            batchSize,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.getUserGroupsPrincipalList,
        refetch,
    };
};
export const useGetDefaultLiveboardsLazyQuery = () => {
    const [_getDefaultLiveboards, { data, error, loading },] = _useGetDefaultLiveboardsLazyQuery({
        fetchPolicy: 'network-only',
    });
    const getDefaultLiveboards = (params) => {
        return _getDefaultLiveboards({
            variables: {
                params,
            },
        });
    };
    return {
        error,
        loading,
        data: data?.getMetadataListAs,
        getDefaultLiveboards,
    };
};
export const useAssignPinboardsToGroupMutation = () => {
    const [_assignPinboards, { data: result, error, loading }] = useMutation(AssignPinboardsToGroupDocument);
    return {
        data: result?.Session__assignPinboardsToGroup,
        error,
        loading,
        assignPinboards: (ids, groupId) => _assignPinboards({
            variables: {
                ids,
                groupId,
            },
        }),
    };
};
export const useGetGroupsPrincipalListQuery = (input) => {
    const { data, error, loading, refetch } = _useGetGroupsPrincipalListQuery({
        variables: {
            data: input,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data: data?.getGroupsPrincipalList,
        refetch,
    };
};
export const useGetUserAndGroupPrincipalListQuery = (pattern, skipIds, isAllOrg) => {
    const { data, error, loading, refetch, } = _useGetUserAndGroupPrincipalListQuery({
        variables: {
            pattern,
            skipIds,
            isAllOrg,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data,
        refetch,
    };
};
export const useGetUserAndGroupPrincipalListLazyQuery = () => {
    const [getUserGroupsPrincipalList, { data, loading, error },] = _useGetUserAndGroupPrincipalListLazyQuery();
    return {
        getUserGroupsPrincipalList,
        data,
        loading,
        error,
    };
};
export const useGetOrgStatisticsMutation = () => {
    const [mutate, { data, loading, error }] = useMutation(GetOrgStatisticsDocument);
    return {
        getOrgStatistics: (type, opts) => {
            const variables = { type };
            if (opts?.allOrgs) {
                variables.allOrgs = true;
            }
            return mutate({ variables });
        },
        count: data?.Session__getOrgStatistics,
        loading,
        error,
    };
};
export const useGetGroupMembersLazyQuery = () => {
    const [getGroupMembers, { loading, data, error },] = _useGetGroupMembersLazyQuery();
    return {
        getGroupMembers,
        error,
        loading,
        data: data?.getGroupMembers,
    };
};
export const useGetGroupDetailsByIdLazyQuery = (ids, id) => {
    const [getGroupById, { data, error, loading },] = _useGetGroupDetailsByIdLazyQuery({
        variables: {
            ids,
            id,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data,
        getGroupById,
    };
};
export const useGetUserDetailsByIdLazyQuery = (ids, orgOverride) => {
    const [getUserById, { data, error, loading },] = _useGetUserDetailsByIdLazyQuery({
        variables: {
            ids,
            orgOverride,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data,
        getUserById,
    };
};
export const useGetUserDetailsByIdWithUsersListLazyQuery = (ids, id, orgOverride) => {
    const [getUserById, { data, error, loading },] = _useGetUserDetailsByIdWithUsersListLazyQuery({
        variables: {
            ids,
            orgOverride,
            id,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data,
        getUserById,
    };
};
export const useSendWelcomeEmailMutation = () => {
    const [_sendWelcomeEmail, { data: result, error, loading }] = useMutation(SendWelcomeEmailDocument);
    return {
        data: result?.Metadata_sendWelcomeEmail,
        error,
        loading,
        sendWelcomeEmail: (id, message, resend = false) => _sendWelcomeEmail({
            variables: {
                id,
                message,
                resend,
            },
        }),
    };
};
export const useResendGroupWelcomeEmailMutation = () => {
    const [_resendGroupWelcomeEmail, { data: result, error, loading },] = useMutation(ResendGroupWelcomeEmailDocument);
    return {
        data: result?.Metadata_resendGroupWelcomeEmail,
        error,
        loading,
        resendGroupWelcomeEmail: (id, message, resend = false) => _resendGroupWelcomeEmail({
            variables: {
                id,
                message,
                resend,
            },
        }),
    };
};
export const useGetUserAndGroupsQuery = (pattern, skipIds, batchSize) => {
    const { data, error, loading, refetch } = _useGetUserAndGroupsQuery({
        variables: {
            pattern,
            skipIds,
            batchSize,
        },
        fetchPolicy: 'no-cache',
    });
    return {
        error,
        loading,
        data,
        refetch,
    };
};
export const useCreateGroupMutation = () => {
    const [_createGroup, { data: result, error, loading }] = useMutation(CreateGroupDocument);
    return {
        data: result?.Session__createGroup,
        error,
        loading,
        createGroup: (params) => _createGroup({
            variables: {
                params,
            },
        }),
    };
};
export const useUpdateGroupMutation = () => {
    const [_updateGroup, { data: result, error, loading }] = useMutation(UpdateGroupDocument);
    return {
        data: result?.Session__updateGroup,
        error,
        loading,
        updateGroup: (params) => _updateGroup({
            variables: {
                params,
            },
        }),
    };
};
export const useDeleteGroupMutation = () => {
    const [_deleteGroup, { data: result, error, loading }] = useMutation(DeleteGroupDocument);
    return {
        data: result?.Session__deleteGroups,
        error,
        loading,
        deleteGroup: (ids) => _deleteGroup({
            variables: {
                ids,
            },
        }),
    };
};
export const useGenerateOtpMutation = () => {
    const [mutate, { data: result, loading, error }] = useMutation(GenerateOtpDocument);
    return {
        generateOtp: (userId) => mutate({ variables: { userId } }),
        data: result?.Session__generateOtp,
        loading,
        error,
    };
};
export const useCreateUserMutation = () => {
    const [_createUser, { data: result, error, loading }] = useMutation(CreateUserDocument);
    return {
        data: result?.Session__createUser,
        error,
        loading,
        createUser: (params) => _createUser({
            variables: {
                params,
            },
        }),
    };
};
export const useUpdateUserMutation = () => {
    const [_updateUser, { data: result, error, loading }] = useMutation(UpdateUserDocument);
    return {
        data: result?.Session__updateUser,
        error,
        loading,
        updateUser: (params) => _updateUser({
            variables: {
                params,
            },
        }),
    };
};
export const useReInviteMemberMutation = () => {
    const [reInviteMember, { data, error, loading }] = useMutation(Teams_ReInviteMemberDocument);
    return {
        data: data?.Teams_reInviteMember,
        error,
        loading,
        reInviteMember: (inviteeId) => reInviteMember({
            variables: {
                inviteeId,
            },
        }),
    };
};
export const useDeleteUserMutation = () => {
    const [_deleteUser, { data: result, error, loading }] = useMutation(DeleteUserDocument);
    return {
        data: result?.Session__deleteUsers,
        error,
        loading,
        deleteUser: (ids, isAllOrgContext) => _deleteUser({
            variables: {
                ids,
                isAllOrgContext,
            },
        }),
    };
};
export const useGetEdocLazyQuery = () => {
    const [_getEdoc, { data, error, loading }] = _useGetEdocLazyQuery({
        fetchPolicy: 'network-only',
    });
    const getEdoc = (objectsToExport, shouldExportDependencies, exportFQN, allOrgsOverride, includeObjId = false, includeObjIdRef = false, includeGuid = true) => {
        return _getEdoc({
            variables: {
                objectsToExport,
                shouldExportDependencies,
                exportFQN,
                allOrgsOverride,
                includeGuid,
                includeObjId,
                includeObjIdRef,
            },
        });
    };
    return {
        getEdoc,
        error,
        loading,
        data: data?.Metadata__getEdoc,
    };
};
export const useAssignUsersToGroupsFromUserMutation = () => {
    const [_assignUsersToGroupsFromUser, { data: result, error, loading },] = useMutation(AssignUsersToGroupsFromUserDocument);
    return {
        data: result?.Session__assignUsersToGroupsFromUser,
        error,
        loading,
        assignUsersToGroupsFromUser: (params) => _assignUsersToGroupsFromUser({
            variables: {
                params,
            },
        }),
    };
};
export const useAddUsersToOrgMutation = () => {
    const [_addUsersToOrg, { data: result, error, loading }] = useMutation(AddUsersToOrgDocument);
    return {
        data: result?.Session__addUsersToOrg,
        error,
        loading,
        addUsersToOrg: (data) => _addUsersToOrg({
            variables: {
                data,
            },
        }),
    };
};
export const useGetUserAccessibleOrgsQuery = () => {
    const { data, error, loading, refetch } = _useGetUserAccessibleOrgsQuery();
    return {
        error,
        loading,
        data: data?.getUserAccessibleOrgs,
        refetch,
    };
};
export const useResetMfaConifgMutation = () => {
    const [_resetMfaConfig, { data: result, error, loading }] = useMutation(ResetMfaConifgDocument);
    return {
        data: result?.Mfa_resetUserConfig,
        error,
        loading,
        resetMfaConfig: (queryData) => _resetMfaConfig({
            variables: {
                data: queryData,
            },
        }),
    };
};
//# sourceMappingURL=user-group-service.js.map